import script from "./LoadingLayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingLayer.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingLayer.vue?vue&type=style&index=0&id=0a712d3c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a712d3c"]])

export default __exports__